(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
    }

    connectedCallback() {
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.submitButton) return;

      const formData = new FormData(this.form);
      const originalText = this.submitButton.textContent;

      this.submitButton.textContent = 'Adding...';
      this.submitButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          this.submitButton.textContent = 'Added!';

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
            })
          );

          setTimeout(() => {
            this.submitButton.textContent = originalText;
            this.submitButton.disabled = false;
          }, 1500);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        this.submitButton.textContent = 'Error';

        setTimeout(() => {
          this.submitButton.textContent = originalText;
          this.submitButton.disabled = false;
        }, 2000);
      }
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }
  } catch(e) { console.error(e); }
})();

})();
